export var GET_SCHEDULE_REPORT_INIT = 'GET_SCHEDULE_REPORT_INIT';
export var GET_SCHEDULE_REPORT_SUCCESS = 'GET_SCHEDULE_REPORT_SUCCESS';
export var GET_SCHEDULE_REPORT_ERROR = 'GET_SCHEDULE_REPORT_ERROR';
export var GET_SCHEDULE_REPORT_DONE = 'GET_SCHEDULE_REPORT_DONE';
